import { MainContent, ModernWebLayout } from "../../components/Layout";
import FavouritesTabGroup from "./FavouritesTabGroup";
import styles from "./FavouritePage.module.scss";

const MyFavouritePage = () => {
  return (
    <ModernWebLayout title="My Favourite">
      <MainContent padding="default">
        <div className={styles.pageHeader}>
          <div className={styles.pageTitle}>My favourites</div>
          <div className={styles.pageSubtitle}>
            Quickly access your saved topics and drug index pages
          </div>
        </div>
        <FavouritesTabGroup />
      </MainContent>
    </ModernWebLayout>
  );
};

export default MyFavouritePage;
